import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://dqxqeskfrtouumlelzwg.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRxeHFlc2tmcnRvdXVtbGVsendnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM4OTk3ODcsImV4cCI6MjA3OTQ3NTc4N30.Bw5KhlZutUSznkbFecCNkffVy_Gtp__uqaBao_h9-zk';

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase variables');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});

export default supabase;